import { useTranslation } from "react-i18next";
import { Icon, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { formatDate } from "utils/dateHelperFunctions";

import type { NoteProps } from "modules/Dayplanner/components/AppointmentCard/components/NotificationIcons";

export const NoDriveNote = ({ note: noDriveNote }: NoteProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      wide
      basic
      content={
        <div className="AppointmentNotePopup">
          <div className="AppointmentNoteTitle">
            <Icon className="circle minus" style={{ color: "#FF0301" }} />
            <span>{t("v8_no_drive_note", "No Drive Note")}</span>
          </div>
          <div className="AppointmentNoteDescription">
            {noDriveNote.updated_by
              ? `${noDriveNote.updated_by.first_name} ${noDriveNote.updated_by.last_name} ${t("v8_updated_no_drive_note", "updated No Drive Note")} `
              : `${noDriveNote.created_by?.first_name} ${noDriveNote.created_by?.last_name} ${t("v8_added_no_drive_note", "added No Drive Note")} `}
            {`${formatDate(noDriveNote.updated_on, DATE_FORMATS_FNS.dateMonthYearTime)}`}
          </div>
          <div className="AppointmentNoteContent">{noDriveNote.note}</div>
        </div>
      }
      trigger={<Icon className="circle minus icon-vertical-align" style={{ color: "#FF0301" }} />}
    />
  );
};
